<template>
  <div class="text-left">
    <GoBackButton />
    <UserData :user="user" />
    <ManageHrCompanies
      ref="manageHrCompanies"
      @newCompaniesAssigned="newCompaniesAssigned"
    />
    <div class="d-flex justify-content-end">
      <b-button
        variant="secondary"
        :disabled="!isNewCompanies"
        class="mr-2"
        @click="$refs.manageHrCompanies.resetCompanies()"
      >
        {{ $t('generic.reset', 'Reset') }}
      </b-button>
      <b-button
        variant="success"
        :disabled="!isNewCompanies"
        @click="$refs.manageHrCompanies.updateCompanies()"
      >
        {{ $t('generic.save', 'Save') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import GoBackButton from '@/components/jobs/shared/GoBackButton';
import UserData from '@/components/jobs/CV/UserData';
import ManageHrCompanies from '@/components/jobs/admin/manageHr/ManageHrCompanies';

export default {
  components: {
    GoBackButton,
    UserData,
    ManageHrCompanies
  },
  data() {
    return {
      userId: null,
      user: null,
      isNewCompanies: false
    }
  },
  mounted() {
    this.userId = this.$route.params.id;
    this.getUser();
  },
  methods: {
    getUser() {
      this.axios.get('/users/' + this.userId)
        .then( response => {
          this.user = response.data;
        })
        .catch();
    },
    newCompaniesAssigned(status) {
      this.isNewCompanies = status;
    }
  }
}
</script>
